export default __webpack_public_path__ + "static/media/trebuc.aff341ba.woff";